import NTopNBottom from '../../components/NTopNBottom'

import bannerImg from '../../assets/zjz/banner.jpg'
import navColor from '../../assets/zjz/nav/color.jpg'
// import navBg from '../../assets/zjz/nav/nav_bg.png'
// import navBgFixed from '../../assets/zjz/nav/nav_bg_fixed.png'

import far1 from '../../assets/zjz/nav/far1.png'
import far1_active from '../../assets/zjz/nav/far1_active.png'
import far2 from '../../assets/zjz/nav/far2.png'
import far2_active from '../../assets/zjz/nav/far2_active.png'
import far3 from '../../assets/zjz/nav/far3.png'
import far3_active from '../../assets/zjz/nav/far3_active.png'

import son1_active from '../../assets/zjz/nav/son1_active.png'
import son2_active from '../../assets/zjz/nav/son2_active.png'
import son3_active from '../../assets/zjz/nav/son3_active.png'

import calcRemFn from '../calcRem'

const navCss = {
  navWrap: {
    paddingTop: 0,
    minHeight: calcRemFn(134),
    backgroundImage: `url(${navColor})`,
    boxSizing: 'border-box'
  },
  navCtn: {
    height: calcRemFn(134),
    backgroundImage: 'none',
  },
  // navCtnFixed: {
  //   height: calcRemFn(134),
  //   backgroundImage: 'none',
  // },
  topBtnLayout: {
    alignItems: 'center',
    padding: `${calcRemFn(16)} ${calcRemFn(27.5)} 0 ${calcRemFn(30)}`
  },
  topBtnBaseCss: {
    height: calcRemFn(22)
  },
  bottomBtnLayout: {
    alignItems: 'center',
    justifyContent: 'center'
  },
  bottomBtnBaseCss: {
    width: calcRemFn(320),
    height: calcRemFn(63.5)
  }
}

const navData = {
  // zjzSpec: true,
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      img: far1,
      img_actived: far1_active,
    },
    {
      key: 'top2',
      show: true,
      img: far2,
      img_actived: far2_active,
    },
    {
      key: 'top3',
      show: true,
      img: far3,
      img_actived: far3_active,
    }
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
        img: '',
        img_actived: son1_active
      }
    ],
    top2: [
      {
        key: '_i1',
        show: true,
        img: '',
        img_actived: son2_active
      }
    ],
    top3: [
      {
        key: '_i1',
        show: true,
        img: '',
        img_actived: son3_active
      }
    ]
  }
}

const pictureList = [
  {
    key: '1_1',
    picNum: 1,
    pid: 95706,
    brand: 'blue'
  },
  {
    key: '2_1',
    picNum: 1,
    pid: 95707,
    brand: 'blue'
  },
  {
    key: '3_1',
    picNum: 1,
    pid: 95709,
    brand: 'blue'
  },
  {
    key: '3_1',
    picNum: 1,
    startIndex: 1,
    pid: 95710,
    brand: 'blue'
  },
  {
    key: '3_1',
    picNum: 1,
    startIndex: 2,
    pid: 95711,
    brand: 'blue'
  },
  {
    key: '3_1',
    picNum: 1,
    startIndex: 3,
    pid: 95712,
    brand: 'blue'
  },
  {
    key: '3_1',
    picNum: 1,
    startIndex: 4,
    pid: 95713,
    brand: 'blue'
  },
  {
    key: '3_1',
    picNum: 1,
    startIndex: 5,
    pid: 95714,
    brand: 'blue'
  }
]
function handlePictures (pictureList) {
  const pictures = []
  pictureList.forEach(item => {
    const { picNum, pid, key, startIndex = 0, brand } = item
    const picList = []
    Array(picNum).fill(0).forEach((item, index) => {
      picList.push(require(`../../assets/zjz/ctn/${key}_${index + startIndex + 1}.jpg`))
    })
    const indexArr = key.split('_')
    pictures.push({
      id: pid,
      type: brand,
      ref: `top${indexArr[0]}_i${indexArr[1]}`,
      farName: `top${indexArr[0]}`,
      sonName: `_i${indexArr[1]}`,
      son: picList
    })
  })
  return pictures
}
const pictures = handlePictures(pictureList)

const topDiff = {
  firstSon: '_i1',
  // top1_i1: 10,
  // top1_i2: 20,
  // top2_i1: 5,
  // top2_i2: 16,
}

export default {
  title: '证件照',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff
}
